class ActionType {
  /**
   * @returns {string}
   * @constructor
   */
  static RISKHUB() {
    return 1;
  }

  static CLIENT() {
    return 2;
  }

  static getTypes() {
    return [
      {
        name: 'riskhub',
        path: 'riskhub',
        typeId: this.RISKHUB(),
      },
      {
        name: 'client',
        path: 'client',
        typeId: this.CLIENT(),
      },
    ];
  }

  static getTypeName(typeId) {
    const type = this.getTypes().filter(r => r.typeId === typeId);
    return type[0].name;
  }

  static getAllStatus() {
    return [
      this.RISKHUB(),
      this.CLIENT(),
    ];
  }
}

export default ActionType;
